









































import Vue from "vue";
import { default as moment } from "moment-timezone";
import { berechneMiete, berechneSteuer } from "../api/Abrechnung";
import { formatDauerLesbar, sortStringsAlnum, Termin, TerminReihe } from "../api/Termine";
import { Studio } from "../api/Studio";

type Modus = "Auswahl" | "Bearbeitung";

export default Vue.extend({
  name: "MonatsabschlussUebersicht",
  props: {
    tag: String,
    studio: Object,
  },
  data() {
    return {
      modus: "Auswahl" as Modus,
      tagesabrechnung: {},
    };
  },
  mounted() {
    (this as any).updateData();
  },
  watch: {
    tag() {
      (this as any).updateData();
    },
    studio() {
      (this as any).updateData();
    },
  },
  methods: {
    openContextMenu(event: { node: any }) {
      console.log("Kontextmenü klappt!");
      console.log(event.node);
    },
    updateData() {
      const setNodes = ((tagesabrechnung: Array<any>) => {
        (this as any).tagesabrechnung = tagesabrechnung;
      }).bind(this);
      this.$store.dispatch("appLoading", true);

      setNodes([]);

      this.$znaApi
        .getTermine(this.studio as Studio, moment(this.tag, "YYYY-MM-DD"), true)
        .subscribe(
          (termine) => {
            const termindaten: any[] = [];
            let anzahlDamen = 0,
              anzahlTermine = 0,
              gesamtDauer = 0;
            const summe = {
              key: "Tageseinnahmen",
              selectable: false,
              styleClass: "p-treetable-footer hat-preise",
              data: {
                dame: "Tageseinnahmen",
                anzahl: "0 T / 0 D",
                dauer: "",
                miete: 0,
                steuer: 0,
                summe: 0,
              },
            };
            (termine as TerminReihe[]).forEach((reihe, index) => {
              if (!reihe.dame || !reihe.dame.id) {
                return;
              }
              const damenDatensatz = {
                key: "tagesdame-" + index,
                selectable: false,
                styleClass: "hat-preise",
                data: {
                  dame: reihe.dame.kuenstlername,
                  anzahl: 0,
                  dauerNumeric: 0,
                  dauer: "0",
                  miete: 0,
                  steuer: 0,
                  summe: 0,
                },
                children: [] as any[],
              };
              reihe.termine
                .filter(
                  (termin: Termin) => !termin.abgesagt && !termin.geblockt
                )
                .forEach((termin: Termin, index: number) => {
                  const miete = berechneMiete(termin);
                  if (miete > 0) {
                    anzahlTermine++;
                    let massageart = termin.massageart?.name;
                    if (termin.massageart?.zweiteDame) {
                      if (reihe.dame?.id == termin.dame?.id) {
                        if (termin.dame2) {
                          massageart += " mit " + termin.dame2?.kuenstlername;
                        } else {
                          massageart += " mit N.N.";
                        }
                      } else if (reihe.dame?.id == termin.dame2?.id) {
                        if (termin.dame2) {
                          massageart += " mit " + termin.dame?.kuenstlername;
                        } else {
                          massageart += " mit N.N.";
                        }
                      }
                    }
                    damenDatensatz.data.anzahl++;
                    damenDatensatz.data.dauerNumeric += termin.dauer;
                    damenDatensatz.data.miete += miete;
                    damenDatensatz.children.push({
                      key: reihe.dame.kuenstlername + "-" + index,
                      selectable: false,
                      data: {
                        termin,
                        massageart,
                        dauer: formatDauerLesbar(termin.dauer),
                        miete,
                      },
                    });
                  }
                });
              if (damenDatensatz.data.anzahl > 0) {
                damenDatensatz.data.dauer = formatDauerLesbar(
                  damenDatensatz.data.dauerNumeric
                );
                damenDatensatz.data.steuer = berechneSteuer(
                  reihe.dame,
                  damenDatensatz.data.miete
                );
                damenDatensatz.data.summe =
                  damenDatensatz.data.miete + damenDatensatz.data.steuer;
                summe.data.miete += damenDatensatz.data.miete;
                summe.data.steuer += damenDatensatz.data.steuer;
                termindaten.push(damenDatensatz);
                anzahlDamen++;
                gesamtDauer += damenDatensatz.data.dauerNumeric;
              }
            });
            // Damen alphabetisch sortieren
            termindaten.sort((zeile1, zeile2) => sortStringsAlnum(zeile1.data.dame as string, zeile2.data.dame as string));
            summe.data.dauer = formatDauerLesbar(gesamtDauer);
            summe.data.anzahl = `${anzahlTermine} T / ${anzahlDamen} D`;
            summe.data.summe = summe.data.miete + summe.data.steuer;
            termindaten.push(summe);
            setNodes(termindaten);
            this.$store.dispatch("appLoading", false);
          },
          (error: any) => {
            this.$toast.add({
              severity: "error",
              summary: "Laden der Daten fehlgeschlagen",
              detail: error,
              life: 3000,
            });
            this.$store.dispatch("appLoading", false);
          }
        );
    },
  },
});
